import styled from "styled-components";
import { COLORS, Z_INDEX } from "../styled";

export const MomentoModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  height: 96%;
  width: 96%;
  top: 2%;
  left: 2%;
  z-index: ${Z_INDEX.HIGHEST + 1}; /* Ensure it is above the overlay */
  background: transparent;
  cursor: arrow;
`;

interface MomentoModalContentProps {
  width?: string;
  height?: string;
}

export const MomentoModalContent = styled.div<MomentoModalContentProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "100%"};
  background: ${COLORS.WHITE};
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${Z_INDEX.HIGHEST};
`;

export const Separator = styled.div`
  height: 10px;
`;

export const BackButtonArea = styled.div`
  display: flex;
  flex-direction: row;
  height: 50px;
  width: 100%;
`;

export const LeftItem = styled.div`
  height: 20px;
  width: 50px;
  padding: 5px 0px 0px 20px;
`;
